import { SETTINGS } from "app/settings";
import { $Router } from 'app/classes/router/router';
import { IHttpResource } from "app/resources";
import { $CurrentUser } from "app/classes/current.user/current.user";

export class AssortmentService {
    constructor(private _request: IHttpResource) {
        const env = $Router.getEnvironment().external;
        const assortmentUrl = SETTINGS.ASSORTMENT_GATEWAY[env];
        this._request.setBaseUrl(assortmentUrl);
        this._request.addHeader({name: "Authorization", data: `Bearer ${$CurrentUser.token}`})

    }
    public async getAssortmentRole(): Promise<string> {
        try {
            const assortmentResponse = await this._request.get('whoami/');
            const filteredRoles = ["supplier", "retailer", "admin"].filter(role => {
                return assortmentResponse[role];
            }).map(role => {
                if (role === "supplier") return "vendor";
                return role;
            });
            return filteredRoles.length > 1 || filteredRoles.length < 1 ? "" : filteredRoles[0];
        } catch (error) {
            console.error('assortment request error:', error)
            if (window.Raven) {
                window.Raven.captureMessage('error requesting assortment user data', error);
            }
            return '';
        }
    }
}
